import ComboFavoriteItemsCard from './ComboFavoriteItemsCard';
import ComboRecentOrderItemsCard from './ComboRecentOrderItemsCard';
import NoFavoriteOrRecentOrders from './NoFavoriteOrRecentOrders';


export default class ComboFavoritesAndRecentOrdersModal extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            isRecentOrder: false,
            isSaveMode: false,
            isFaveOrder: true,
           
            //recentOrderListData: this.recentOrderData, //this.recentOrderData.UserBasketRecentOrder[0].products,
            faveItemsListData: this.props.data.UserBasketFavorite ? this.props.data.UserBasketFavorite.reverse() : this.props.data.UserBasketFavorite
        }
        this.recentOrderTabTarget = "#recent-orders";
        this.getNewFaveData = this.getNewFaveData.bind(this);
        this.getFavCardIdForRemoval = this.getFavCardIdForRemoval.bind(this);
        this.activateDropdown = this.activateDropdown.bind(this);
        this.openCloseAccordion = this.openCloseAccordion.bind(this);
        this.setFaveOrderHeading = this.setFaveOrderHeading.bind(this)
        this.setRecentOrderHeading = this.setRecentOrderHeading.bind(this)
       // this.getRecentOrderCardIdForRemoval = this.getRecentOrderCardIdForRemoval.bind(this)
       
       // this.newFaveData = this.props.data.FavoritesData.UserBasketFavorite[0].product
        this.faveCardSet = [];
        this.recentCardSet=[];

    }

    openCloseAccordion(){
        var dropDownOpentriggerClass = ".see-full-txt"
        var dropDownClosetriggerClass = ".close-txt"
        var favCardchevron = ".down-arrow"
    
    
        $(favCardchevron).unbind().click(function(e){
            var currentFavChevronId = e.currentTarget.id
            if($(this).hasClass("down-rotate")){
                $("#" + currentFavChevronId + dropDownClosetriggerClass).click()
                //console.log('this event favourite order close trigger');
                $(this).removeClass("down-rotate")
            }else{
                $("#" + currentFavChevronId + dropDownOpentriggerClass).click() 
            }
        })
        this.activateDropdown(dropDownClosetriggerClass, dropDownOpentriggerClass, "closeDrawer");
        this.activateDropdown(dropDownOpentriggerClass, dropDownClosetriggerClass, "openDrawer");
    }

    setFaveOrderHeading(e) {
        this.setState({isFaveOrder: true});
     }
   
    setRecentOrderHeading(e) {
         this.setState({isFaveOrder: false});
     }

    getNewFaveData(newFaveData){
    //this.props.sendNotificationForFavecardUpdate()
    $('.modal-body').scrollTop(0);
    this.state.faveItemsListData.unshift(newFaveData);
     this.state.isFaveOrder = true;
     $(".nav-link.fav_pill").click();
     
     this.setState({faveItemsListData: this.state.faveItemsListData,
        isFaveOrder: this.state.isFaveOrder
        //recentOrderListData: this.state.recentOrderListData
    }) 
}

getFavCardIdForRemoval(cardId) {
    console.log('getFavCardIdForRemoval--' + cardId);
    var faveItemsListDataObj = this.state.faveItemsListData.filter((favID) => {
        return (cardId != favID.id)
    });   
    this.setState({faveItemsListData: faveItemsListDataObj})
}

activateDropdown(dropdownTriggerLinkClass, dropdownUnTriggerLinkClass, slideDirection){
    var allTriggerElems = document.querySelectorAll(dropdownTriggerLinkClass)
    var selectedElemId = "";
    var faveMealOpenAccordion = "";
    var faveMealCloseAccordion ="";


   $(dropdownTriggerLinkClass).click(function(e){  
    selectedElemId = e.target.id
        for (let selectedElemLink = 0; selectedElemLink < allTriggerElems.length; selectedElemLink++) {
             if((allTriggerElems[selectedElemLink].id == selectedElemId) && (allTriggerElems[selectedElemLink].id != "")){    
                $("#"+selectedElemId + dropdownTriggerLinkClass).addClass("hide-link").siblings("span"+dropdownUnTriggerLinkClass).removeClass("hide-link");
                $("#"+selectedElemId + dropdownTriggerLinkClass).siblings(".down-arrow").addClass("down-rotate");

                faveMealOpenAccordion = $("#"+selectedElemId+".fav-meal-container .pre-wrapper").hide().siblings(".exp-container");
                faveMealCloseAccordion = $("#"+selectedElemId+".fav-meal-container .pre-wrapper").show().siblings(".exp-container");

                if(slideDirection == "openDrawer"){
                    faveMealOpenAccordion.slideDown()
                }else{
                    faveMealCloseAccordion.slideUp(300)
                    //console.log('favourite order close trigger');
                    $("#" + selectedElemId + dropdownTriggerLinkClass).siblings(".down-arrow").removeClass("down-rotate");
                    //$(".down-arrow").removeClass("down-rotate");
                }  
               
                $("#"+selectedElemId + dropdownTriggerLinkClass).parent(".closed-acc").addClass("acc-open");
                
             }
          }
        })
}

componentDidMount(){ 
    var reactRefThis = this;
    $(document).ready(function() {
    reactRefThis.openCloseAccordion()

   /*order see full accordion ends */

   
    /*Favorite and recent tabs code starts */
    $('.rec-orders a.nav-link').click(function(e) {
        var cind = $(this).parent(".nav-item").index();
        $(this).parents(".tab_container").siblings(".common-tabs").eq(cind).removeClass("hide-sec").siblings(".common-tabs").addClass("hide-sec");

    })
    /*Favorite and recent tabs code ends */


    /*Recent orders favorite modal code starts */
    $(".mobile-button").on("click",function(e) {
        $(".modal-backdrop").addClass("mobile-save-backdrop");
    });

    $(window).on('resize', function(){
        var win = $(this); //this = window
        if (win.width() >= 768) { 
            $("#mob-fav").hide();
            $(".modal-backdrop").removeClass("mobile-save-backdrop");
            //console.log($(window).width());
        }
    });

    $(".mobile-modal-content .save-sec-closebtn").click(function() {
        $(".modal-backdrop").removeClass("mobile-save-backdrop");
    });
});
    /*Recent orders favorite modal code ends */

        //rebind the corresponding methods anytime a pill is clicked
    $(".nav-link.fav_pill , .nav-link.recent_pill").click(function (e) {
            setTimeout(()=>{reactRefThis.openCloseAccordion(); 
                DE.FavesAndReorder.bindEvents();
            }, 250)

        var tabHead = $("#recordnone .fav-heading");
        if ($(e.currentTarget).hasClass("fav_pill")) { tabHead.html(tabHead.data("fav"));  }
        else {  tabHead.html(tabHead.data("recent"));}
       });
}

  render() {
 var noFavoriteDataAvailable = this.props.data.FavoritesData;
   return (
            <div>
  {/*<!-- ====  Recent orders none code starts ==== -->*/}
           <div className="modal modal_outer docked-right-modal fade no-meals" id="recordnone" tabindex="-1" role="dialog" aria-labelledby="recordnone_label" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-body delivery">

                        {/*<!-- header button  -->*/}
                        <div className="header-btns">
                            <div className="position-relative close-btn clearfix">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <img src="/images/2/icons/ihop-modal-close.png" className="img-fluid" alt="close button" />
                                </button>
                                <div className="fav-heading h3" data-fav={this.props.data.TabHeadingFavoriteOrders} data-recent={this.props.recentOrders.TabHeadingRecentOrders}>{this.state.isFaveOrder ? this.props.data.TabHeadingFavoriteOrders : this.props.recentOrders.TabHeadingRecentOrders}</div>
                            </div>
                        </div>
                        {/*<!-- header button  -->*/}


                        <div className="modal-padding">
                            {/*<!--favorite and recent order tab code starts-->*/}
                            <div className="tab_container">
                                <ul className="nav nav-pills iHop-Gotham fav-menu justify-content-center rec-orders" role="list">
                                    <li className="nav-item text-center">
                                           <a className="nav-link active fav_pill" data-toggle="pill" onClick={this.setFaveOrderHeading} href="#favorites" role="button">{this.props.data.TabHeadingFavoriteOrders}</a>
                                    </li>
                                    <li className="nav-item text-center">
                                           <a className="nav-link recent_pill" data-toggle="pill" onClick={this.setRecentOrderHeading} href={this.recentOrderTabTarget} role="button">{this.props.recentOrders.TabHeadingRecentOrders}</a>
                                    </li>
                                </ul>
                           </div>
                            {/*<!--favorite and recent order tab code ends-->*/}

                            {/*fav Order Tabs */}

                               <div className="fav-ord-con common-tabs">

                             {/*1. this.faveOrderObj has data?*/}
  {                              
      (this.state.faveItemsListData && this.state.faveItemsListData.length > 0) &&
this.state.faveItemsListData.map(favoriteOrder => {

    return(
    <ComboFavoriteItemsCard favoriteOrder={favoriteOrder} favoriteData={this.props.data}
    sendFavCardIdForRemoval = {this.getFavCardIdForRemoval} />
    )
})
}
  
{/*2. this.faveOrderObj has no data?*/}
{/*!this.props.data.UserBasketFavorite || this.props.data.UserBasketFavorite.length == 0 &&*/}
{!this.state.faveItemsListData  &&
    <NoFavoriteOrRecentOrders 
      title = {this.props.data.NoFavoriteTitle}
      subTitle = {this.props.data.NoFavoriteSubTitle}
      buttonText = {this.props.data.FavoritingButtonText}
      target={this.recentOrderTabTarget}
    />  
}
</div>

{/*recent Order Tabs */}
<div className="rec-ord-con common-tabs hide-sec">
   {
        (this.props.recentOrders.Orders && this.props.recentOrders.Orders.length > 0) &&
        this.props.recentOrders.Orders.map(recentOrder => {
            return(
                    <ComboRecentOrderItemsCard recentOrder={recentOrder} recentOrderData={this.props.recentOrders}                                                                       
                        sendNewFaveData = {this.getNewFaveData} />
            )
        })  
    }
                    
                       {(!this.props.recentOrders.Orders || this.props.recentOrders.Orders.length == 0) &&
                            <NoFavoriteOrRecentOrders 
                              title = {this.props.recentOrders.NoRecentOrdersTitle}
                              subTitle = {this.props.recentOrders.NoRecentOrdersSubTitle}
                              buttonText = {this.props.recentOrders.StartOrderButtonText}
                              target={this.props.landingPageUrl}
                            />
                        }
                              </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
       {/* <!-- ====  Recent orders none code ends ==== -->*/}

                 
            </div>
        );
    }
}




